<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import learningApiUser from '@src/services/api/learning/user'
import DefineValidation from '@services/validation/DefineValidation'
import { useLearningAuthStore } from '@stores/auth'
import Modal from '@components/modal/Modal.vue'

const { accessToken } = storeToRefs(useLearningAuthStore())

const router = useRouter()
const accessTokenCopy = accessToken.value

const { errors, meta, handleSubmit, handleReset, models } = new DefineValidation((modules) => {
  if (accessToken.value) {
    return {
      subject: modules.string().required().label('件名'),
      body: modules.string().required().label('本文')
    }
  } else {
    return {
      lastName: modules.string().required().label('名字'),
      firstName: modules.string().required().label('名前'),
      email: modules.string().email().required().label('メールアドレス'),
      subject: modules.string().required().label('件名'),
      body: modules.string().required().label('本文')
    }
  }
})

const sendButtonDisabled = computed(() => {
  return !(meta.value.valid && meta.value.dirty)
})

const showCompleteModal = ref(false)

const toTop = () => {
  showCompleteModal.value = false
  if (accessToken.value) {
    router.push({
      name: 'Dashboard'
    })
  } else {
    window.location.href = '/index.html'
  }
}

const sendForm = handleSubmit(async (values) => {
  if (accessToken.value) {
    const body = {
      displays: {
        subject: models.subject.value,
        body: models.body.value
      }
    }
    console.log('bodyログイン済み', body)
    learningApiUser.postInquiry(body).then((res) => {
      console.log('postInquiry res', res.data)
      showCompleteModal.value = true
    }).catch((err) => {
      console.error('postInquiry err', err)
    })
  } else {
    const body = {
      displays: {
        subject: models.subject.value,
        body: models.body.value
      },
      sender_by: {
        name: [models.lastName.value, models.firstName.value],
        email: models.email.value
      }
    }
    console.log('bodyログイン済み', body)
    learningApiUser.postInquiryGeust(body).then((res) => {
      console.log('postInquiry res', res.data)
      showCompleteModal.value = true
    }).catch((err) => {
      console.error('postInquiry err', err)
    })
  }
})
</script>

<template>
  <section>
    <div class="container">
      <h2>お問い合わせ</h2>
      <p>お問い合わせ内容を入力し、送信ボタンを押してください。</p>
      <p
        v-if="!accessTokenCopy"
        class="attention"
      >
        登録者の方はログインしてお問い合わせ下さい。
      </p>
      <form @submit.prevent="sendForm">
        <div class="c-compBox">
          <div
            v-if="!accessTokenCopy"
            class="p-form-field"
          >
            <label
              class="c-input-label"
            ><span class="c-form-required">必須</span>氏名</label>
            <input
              id="password"
              v-model="models.lastName.value"
              type="text"
              class="c-input-text c-input-text--separate"
              placeholder="山田"
              autocomplete="off"
              maxlength="256"
            ><input
              id="password"
              v-model="models.firstName.value"
              type="text"
              class="c-input-text c-input-text--separate"
              placeholder="太郎"
              autocomplete="off"
              maxlength="256"
            >
            <span
              v-if="errors.lastName"
              class="c-validationError"
            >{{ errors.lastName }}</span>
            <span
              v-if="errors.firstName"
              class="c-validationError"
            >{{ errors.firstName }}</span>
          </div>
      
          <div
            v-if="!accessTokenCopy"
            class="p-form-field"
          >
            <label
              class="c-input-label"
            ><span class="c-form-required">必須</span>メールアドレス</label>
            <input
              v-model="models.email.value"
              type="text"
              class="c-input-text"
              placeholder="sample@example.com"
              autocomplete="off"
              maxlength="256"
            >
            <span
              v-if="errors.email"
              class="c-validationError"
            >{{ errors.email }}</span>
          </div>

          <div class="p-form-field">
            <label
              for="subject"
              class="c-input-label"
            ><span class="c-form-required">必須</span>件名</label>
            <select
              v-model="models.subject.value"
            >
              <option value="">
                選択してください
              </option>
              <option value="継続的研修のお問合せ">
                継続的研修のお問合せ
              </option>
              <option value="申込み方法のお問合せ">
                申込み方法のお問合せ
              </option>
              <option value="決済方法の問合せ">
                決済方法の問合せ
              </option>
              <option value="会場のお問合せ">
                会場のお問合せ
              </option>
              <option value="サイト操作に関するお問合せ">
                サイト操作に関するお問合せ
              </option>
              <option value="その他">
                その他
              </option>
            </select>
            <div class="c-validationError u-text-left">
              {{ errors.subject }}
            </div>
          </div>
          <div class="p-form-field">
            <label
              for="body"
              class="c-input-label"
            ><span class="c-form-required">必須</span>本文</label>
            <textarea
              id="body"
              v-model="models.body.value"
              type="text"
              class="c-input-textarea"
              placeholder="本文"
              autocomplete="off"
              maxlength="4000"
            />
            <div class="c-validationError u-text-left">
              {{ errors.body }}
            </div>
          </div>
          
          <div class="btnContainer">
            <button
              type="submit"
              class="c-button c-button--medium c-button--yellow"
              :disabled="sendButtonDisabled"
            >
              送信
            </button>
            <a
              class="c-button c-button--medium c-button--border"
              @click="$router.go(-1)"
            >
              戻る
            </a>
          </div>
        </div>
      </form>
    </div>

    <Modal :show="showCompleteModal">
      <template #body>
        <div class="l-modal__body">
          <h2 class="l-modal__ttl">
            お問い合わせを送信しました。
          </h2>
          <div class="l-modal__buttons">
            <button
              class="c-modalBtn c-modalBtn--single c-modalBtn--gray"
              type="button"
              @click="toTop"
            >
              戻る
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </section>
</template>

<style scoped lang="scss">
.container {
  h2 {
    padding: 30px 0 15px;
    font-size: 26px;
    text-align: left;
    font-weight: bold;
  }
  select {
    appearance: auto;
    outline: none;
    border: 1px solid #333;
    border-radius: 4px;
    font-size: 16px;
    margin-top: 8px;
    padding: 4px 10px;
    cursor: pointer;
  }
  textarea {
    font-size: 16px;
  }
}
.btnContainer {
  margin-top: 20px;

  a {
    text-decoration: none;
  }
}

.c-compBox {
  margin-top: 26px;
}

.attention {
  color: red;
}
</style>
